import {Component, HostListener, OnInit} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {firstValueFrom} from "rxjs";
import { MarkdownComponent } from '../../components/markdown/markdown.component';
import { NgFor } from '@angular/common';
import { NavbarComponent } from '../../components/navbar/navbar.component';

interface Heading {
  depth: number ;
  title: string ;
  id: string ;
}

@Component({
    selector: 'app-docs',
    templateUrl: './docs.component.html',
    styleUrls: ['./docs.component.scss'],
    standalone: true,
    imports: [NavbarComponent, NgFor, MarkdownComponent]
})
export class DocsComponent implements OnInit {

  loading: boolean = false ;
  markup: string = "";

  headings: Heading[] = [] ;

  @HostListener('click', ['$event'])
  onClick(event: any): void {
    event.preventDefault();
    // find anchor
    const anchor = event.target.closest("a");
    if (!anchor) return;
    // navigate
    const href = anchor.getAttribute('href')
    console.log(href) ;

    this.scrollTo(href.substring(1));
  }


  constructor(
    private _http: HttpClient
  ) {

  }

  async ngOnInit() {

    this.loading = true ;

    this.markup = await firstValueFrom(this._http.get('assets/teacher-guide.md', {responseType: 'text'})) ;

    this.headings = [] ;

    const matches = this.markup.matchAll(/(#+) ([\w\s]+) \{#([\w-]+)\}/g) ;
    for (let match of matches) {
      this.headings.push({
        depth: match[1].length,
        title: match[2],
        id: match[3]
      })
    }
    console.log(this.headings) ;

    this.loading = false ;
  }

  scrollTo(id:string) {


    const el = document.getElementById(id) ;
    if (el)
      el.scrollIntoView();


  }

}
